import styled from 'styled-components';

export const PortfolioQuantityStyled = styled.b`
  margin-left: 0.5rem;
`;
